module.exports = __webpack_public_path__ + "img/stena22.c5355073.jpg";